import React from "react";
import BannerImg from "../../../assets/img/BannerAbout.png";
import BannerImg2 from "../../../assets/img/BannerAbout2.png";

import { useNavigate } from "react-router-dom";

const Banner = () => {
  const navigate = useNavigate();
  return (
    <section id="conocenos" className="py-5 text-white">
      <div className="container">
        <div className="row align-items-center">
          {/* Texto */}
          <div className="col-md-6 mb-4 mb-md-0 text-md-start text-center">
            <h1 className="fw-bold ">Sobre Nosotros</h1>
            <p>
              En Billy Browns, vivimos por una sola cosa: hacer hamburguesas que
              realmente valen la pena. Usamos carne 100% de calidad,
              ingredientes frescos y combinaciones que te hacen volver. No
              buscamos ser los más gourmet ni los más rápidos, pero sí los que
              no fallan. Acá se viene a comer rico, sin vueltas, con sabor de
              verdad. Somos una casa de hamburguesas con alma callejera,
              atención cercana y una obsesión por hacer las cosas bien desde la
              plancha hasta el pan.
            </p>
            <button
              className="btn-cta"
              onClick={() => {
                navigate("/login");
              }}
            >
              ¡Pedi tu Billy!
            </button>
          </div>

          <div className="col-md-6 text-center">
            <img
              src={BannerImg}
              alt="Banner"
              className="img-fluid"
              style={{ maxHeight: "500px" }}
            />
          </div>
        </div>
        <hr/>
        <div className="row align-items-center mt-5">
          {/* Texto */}
          <div className="col-md-6 text-center">
            <img
              src={BannerImg2}
              alt="Banner"
              className="img-fluid"
              style={{ maxHeight: "500px" }}
            />
          </div>
          <div className="col-md-6 mb-4 mb-md-0 text-md-end text-center mt-1">
            <h1 className="fw-bold ">Apasionados en lo que hacemos</h1>
            <p>
              Cuidamos cada detalle, desde la carne hasta la cocción, porque no
              creemos en las medias tintas. Si vamos a hacer hamburguesas, las
              hacemos con todo. Esa es nuestra forma de trabajar, de vivir y de
              servir. Acá no hay fórmulas mágicas, hay amor por la cocina y
              ganas de hacer las cosas bien. Porque sí, somos fanáticos de lo
              que hacemos. Y se nota.
            </p>
            <button
              className="btn-cta"
              onClick={() => {
                navigate("/login");
              }}
            >
              ¡Pedi tu Billy!
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
